import React from 'react'
import PropTypes from 'prop-types'
import { map } from 'lodash'
import { filterPostsByTopicSlug } from '../../lib'
import TopicSection from '../topic-section'

const NUM_VISIBLE_POSTS = 4

const ParentingView = ({ posts, subTopics }) => (
  <React.Fragment>
    {map(subTopics, (topic, idx) => {
      let filteredPosts = filterPostsByTopicSlug(posts, topic.slug)
      return (
        <TopicSection
          key={'topic_section_' + topic.slug}
          showTopics={false}
          showAllButton={filteredPosts.length > NUM_VISIBLE_POSTS}
          topic={{ name: topic.name, slug: topic.slug }}
          posts={filteredPosts.slice(0, NUM_VISIBLE_POSTS)}
        />
      )
    })}
  </React.Fragment>
)

ParentingView.propTypes = {
  posts: PropTypes.array,
  subTopics: PropTypes.array,
}

export default ParentingView
